import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosinstance from "../axios/axiosInstance";
import "./RecentMatches.css";

const RecentMatches = () => {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchRecentMatches = async () => {
            try {
                const response = await axiosinstance.get('/match/recent');
                if (response.data && response.data.matches) {
                    setMatches(response.data.matches);
                }
            } catch (error) {
                console.error("Error fetching recent matches:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRecentMatches();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    const getMatchType = (overs) => {
        if (!overs) return 'Match';
        if (overs <= 10) return 'T10';
        if (overs <= 20) return 'T20';
        if (overs <= 50) return 'ODI';
        return 'Test';
    };

    const getTeamImage = (pic) => pic || '/Group_Avatar/1.png';

    if (!loading && matches.length === 0) return null;

    if (loading) {
        return (
            <div className="recent-matches-wrapper">
                <div className="container">
                    <div className="rm-header cf-reveal">
                        <span className="rm-eyebrow">Recent</span>
                        <h2>Recent Matches</h2>
                        <p>Latest games from the community</p>
                    </div>
                </div>
                <div className="rm-cards">
                    {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="rm-card rm-skeleton">
                            <div className="skeleton-shimmer"></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="recent-matches-wrapper">
            <div className="container">
                <div className="rm-header cf-reveal">
                    <span className="rm-eyebrow">Recent</span>
                    <h2>Recent Matches</h2>
                    <p>Latest games from the community</p>
                </div>
            </div>

            <div className="rm-cards">
                    {matches.map((match) => (
                        <div
                            key={match.match_id}
                            className="rm-card"
                            onClick={() => navigate(`/match/highlights/${match.match_id}`)}
                        >
                            <div className="rm-card-top">
                                <span className="rm-format">{getMatchType(match.overs)}</span>
                                <span className="rm-date">{formatDate(match.match_date)}</span>
                            </div>

                            <div className="rm-teams">
                                <div className="rm-team">
                                    <img 
                                        src={getTeamImage(match.team_a?.pic)} 
                                        alt=""
                                        onError={(e) => { e.target.src = '/Group_Avatar/1.png'; }}
                                    />
                                    <div className="rm-team-info">
                                        <span className="rm-team-name">{match.team_a?.name}</span>
                                        <span className="rm-team-score">{match.team_a?.score}</span>
                                    </div>
                                </div>

                                <div className="rm-team">
                                    <img 
                                        src={getTeamImage(match.team_b?.pic)} 
                                        alt=""
                                        onError={(e) => { e.target.src = '/Group_Avatar/1.png'; }}
                                    />
                                    <div className="rm-team-info">
                                        <span className="rm-team-name">{match.team_b?.name}</span>
                                        <span className="rm-team-score">{match.team_b?.score}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="rm-result">
                                {match.win_margin || `${match.winner_team_name} won`}
                            </div>

                            <div className="rm-footer">
                                <span>View Scorecard →</span>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default RecentMatches;
